import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6f1d25f2 = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _3df5bec0 = () => interopDefault(import('../pages/account/general-info.vue' /* webpackChunkName: "pages/account/general-info" */))
const _22ce405c = () => interopDefault(import('../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _12162bfe = () => interopDefault(import('../pages/account/referral-info.vue' /* webpackChunkName: "pages/account/referral-info" */))
const _f7bd69da = () => interopDefault(import('../pages/account/user-info.vue' /* webpackChunkName: "pages/account/user-info" */))
const _e56dca5e = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _0ad1870a = () => interopDefault(import('../pages/checkout/index.js' /* webpackChunkName: "pages/checkout/index" */))
const _948c812e = () => interopDefault(import('../pages/checkout/order-summary.vue' /* webpackChunkName: "pages/checkout/order-summary" */))
const _1942ed48 = () => interopDefault(import('../pages/checkout/payment.vue' /* webpackChunkName: "pages/checkout/payment" */))
const _55a08f63 = () => interopDefault(import('../pages/checkout/personal-details.vue' /* webpackChunkName: "pages/checkout/personal-details" */))
const _4bfef2b0 = () => interopDefault(import('../pages/event-list-page.vue' /* webpackChunkName: "pages/event-list-page" */))
const _306768db = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _50af7ffc = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _44b59071 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _5409a21f = () => interopDefault(import('../pages/magazine.vue' /* webpackChunkName: "pages/magazine" */))
const _20082cf4 = () => interopDefault(import('../pages/magazine/article.vue' /* webpackChunkName: "pages/magazine/article" */))
const _43098a9e = () => interopDefault(import('../pages/magazine/category.vue' /* webpackChunkName: "pages/magazine/category" */))
const _feda120c = () => interopDefault(import('../pages/magazine/magazine-wrapper.vue' /* webpackChunkName: "pages/magazine/magazine-wrapper" */))
const _3d2ddf09 = () => interopDefault(import('../pages/order-success.vue' /* webpackChunkName: "pages/order-success" */))
const _1e7e0860 = () => interopDefault(import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */))
const _03f99368 = () => interopDefault(import('../pages/password-reset.vue' /* webpackChunkName: "pages/password-reset" */))
const _7f1e74f1 = () => interopDefault(import('../pages/ping-default.vue' /* webpackChunkName: "pages/ping-default" */))
const _4cc0fed7 = () => interopDefault(import('../pages/ping-optimized.vue' /* webpackChunkName: "pages/ping-optimized" */))
const _df316b06 = () => interopDefault(import('../pages/ping.vue' /* webpackChunkName: "pages/ping" */))
const _074cd0ea = () => interopDefault(import('../pages/root-domain/home.vue' /* webpackChunkName: "" */))
const _0eebda1a = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _a5de770c = () => interopDefault(import('../pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _c25a9b72 = () => interopDefault(import('../pages/stripe-3d-auth-complete.vue' /* webpackChunkName: "pages/stripe-3d-auth-complete" */))
const _2ad0d202 = () => interopDefault(import('../pages/sub-domain/home.vue' /* webpackChunkName: "" */))
const _360d43e5 = () => interopDefault(import('../pages/teamevent/index.vue' /* webpackChunkName: "pages/teamevent/index" */))
const _bb6b3902 = () => interopDefault(import('../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _62db3ec6 = () => interopDefault(import('../pages/terms-supplier.vue' /* webpackChunkName: "pages/terms-supplier" */))
const _e0924fd6 = () => interopDefault(import('../pages/auth/social-login.vue' /* webpackChunkName: "pages/auth/social-login" */))
const _4ac12894 = () => interopDefault(import('../pages/city-category/city-category.vue' /* webpackChunkName: "pages/city-category/city-category" */))
const _ba132d42 = () => interopDefault(import('../pages/embedded/booking.vue' /* webpackChunkName: "pages/embedded/booking" */))
const _53b8581c = () => interopDefault(import('../pages/embedded/button.vue' /* webpackChunkName: "pages/embedded/button" */))
const _01d72b64 = () => interopDefault(import('../pages/login/forgot-password.vue' /* webpackChunkName: "pages/login/forgot-password" */))
const _d2538942 = () => interopDefault(import('../pages/partner/booking-solution.vue' /* webpackChunkName: "pages/partner/booking-solution" */))
const _10311744 = () => interopDefault(import('../pages/partner/pricing.vue' /* webpackChunkName: "pages/partner/pricing" */))
const _b843436a = () => interopDefault(import('../pages/root-domain/giftcard.vue' /* webpackChunkName: "pages/root-domain/giftcard" */))
const _54a6e134 = () => interopDefault(import('../pages/special-giftcard/special-giftcard.vue' /* webpackChunkName: "pages/special-giftcard/special-giftcard" */))
const _74cc1363 = () => interopDefault(import('../pages/sub-domain/giftcard.vue' /* webpackChunkName: "pages/sub-domain/giftcard" */))
const _466156f0 = () => interopDefault(import('../pages/t/general-event-list-page.vue' /* webpackChunkName: "pages/t/general-event-list-page" */))
const _5cc41141 = () => interopDefault(import('../pages/c/_categorySlug.vue' /* webpackChunkName: "pages/c/_categorySlug" */))
const _2971bd1e = () => interopDefault(import('../pages/city/_city.vue' /* webpackChunkName: "pages/city/_city" */))
const _3e4d8090 = () => interopDefault(import('../pages/e/_event.vue' /* webpackChunkName: "pages/e/_event" */))
const _2910d15c = () => interopDefault(import('../pages/e/_event/index.ts' /* webpackChunkName: "pages/e/_event/index" */))
const _b7e72bba = () => interopDefault(import('../pages/e/_event/BasicDetails.vue' /* webpackChunkName: "pages/e/_event/BasicDetails" */))
const _f6177d76 = () => interopDefault(import('../pages/e/_event/EventBreadcrumbs.vue' /* webpackChunkName: "pages/e/_event/EventBreadcrumbs" */))
const _05bc6b12 = () => interopDefault(import('../pages/e/_event/EventIconList.vue' /* webpackChunkName: "pages/e/_event/EventIconList" */))
const _0a2aad4a = () => interopDefault(import('../pages/e/_event/EventIconList/EventIconListTable.vue' /* webpackChunkName: "pages/e/_event/EventIconList/EventIconListTable" */))
const _643f8b33 = () => interopDefault(import('../pages/e/_event/Gallery.vue' /* webpackChunkName: "pages/e/_event/Gallery" */))
const _393d716e = () => interopDefault(import('../pages/e/_event/LocationAndMap.vue' /* webpackChunkName: "pages/e/_event/LocationAndMap" */))
const _c1a3a7d8 = () => interopDefault(import('../pages/e/_event/PrivateEventInfo.vue' /* webpackChunkName: "pages/e/_event/PrivateEventInfo" */))
const _530bdcd4 = () => interopDefault(import('../pages/e/_event/ReviewShowcase.vue' /* webpackChunkName: "pages/e/_event/ReviewShowcase" */))
const _1e1629a0 = () => interopDefault(import('../pages/e/_event/composables/useEventBreadcrumbs.ts' /* webpackChunkName: "pages/e/_event/composables/useEventBreadcrumbs" */))
const _0541edb6 = () => interopDefault(import('../pages/e/_event/composables/useKftBuyBox.ts' /* webpackChunkName: "pages/e/_event/composables/useKftBuyBox" */))
const _4db5bc14 = () => interopDefault(import('../pages/p/_permalink.vue' /* webpackChunkName: "pages/p/_permalink" */))
const _00bf7940 = () => interopDefault(import('../pages/preview/_previewPermalink.vue' /* webpackChunkName: "pages/preview/_previewPermalink" */))
const _09dfb092 = () => interopDefault(import('../pages/review/_event.vue' /* webpackChunkName: "pages/review/_event" */))
const _16d9f15d = () => interopDefault(import('../pages/teamevent/_city.vue' /* webpackChunkName: "pages/teamevent/_city" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de-de/account/",
    component: _6f1d25f2,
    pathToRegexpOptions: {"strict":true},
    name: "account___de-de",
    children: [{
      path: "general-info/",
      component: _3df5bec0,
      pathToRegexpOptions: {"strict":true},
      name: "account-general-info___de-de"
    }, {
      path: "orders/",
      component: _22ce405c,
      pathToRegexpOptions: {"strict":true},
      name: "account-orders___de-de"
    }, {
      path: "referral-info/",
      component: _12162bfe,
      pathToRegexpOptions: {"strict":true},
      name: "account-referral-info___de-de"
    }, {
      path: "user-info/",
      component: _f7bd69da,
      pathToRegexpOptions: {"strict":true},
      name: "account-user-info___de-de"
    }]
  }, {
    path: "/de-de/checkout/",
    component: _e56dca5e,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "",
      component: _0ad1870a,
      pathToRegexpOptions: {"strict":true},
      name: "checkout___de-de"
    }, {
      path: "order-summary/",
      component: _948c812e,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-order-summary___de-de"
    }, {
      path: "payment/",
      component: _1942ed48,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-payment___de-de"
    }, {
      path: "personal-details/",
      component: _55a08f63,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-personal-details___de-de"
    }]
  }, {
    path: "/de-de/event-list-page/",
    component: _4bfef2b0,
    pathToRegexpOptions: {"strict":true},
    name: "event-list-page___de-de"
  }, {
    path: "/de-de/faq/",
    component: _306768db,
    pathToRegexpOptions: {"strict":true},
    name: "faq___de-de"
  }, {
    path: "/de-de/impressum/",
    component: _50af7ffc,
    pathToRegexpOptions: {"strict":true},
    name: "impressum___de-de"
  }, {
    path: "/de-de/login/",
    component: _44b59071,
    pathToRegexpOptions: {"strict":true},
    name: "login___de-de"
  }, {
    path: "/de-de/magazine/",
    component: _5409a21f,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___de-de",
    children: [{
      path: "article/",
      component: _20082cf4,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-article___de-de"
    }, {
      path: "category/",
      component: _43098a9e,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-category___de-de"
    }, {
      path: "magazine-wrapper/",
      component: _feda120c,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-magazine-wrapper___de-de"
    }]
  }, {
    path: "/de-de/order-success/",
    component: _3d2ddf09,
    pathToRegexpOptions: {"strict":true},
    name: "order-success___de-de"
  }, {
    path: "/de-de/partner/",
    component: _1e7e0860,
    pathToRegexpOptions: {"strict":true},
    name: "partner___de-de"
  }, {
    path: "/de-de/password-reset/",
    component: _03f99368,
    pathToRegexpOptions: {"strict":true},
    name: "password-reset___de-de"
  }, {
    path: "/de-de/ping-default/",
    component: _7f1e74f1,
    pathToRegexpOptions: {"strict":true},
    name: "ping-default___de-de"
  }, {
    path: "/de-de/ping-optimized/",
    component: _4cc0fed7,
    pathToRegexpOptions: {"strict":true},
    name: "ping-optimized___de-de"
  }, {
    path: "/de-de/ping/",
    component: _df316b06,
    pathToRegexpOptions: {"strict":true},
    name: "ping___de-de"
  }, {
    path: "/de-de/root-domain/",
    component: _074cd0ea,
    props: true,
    name: "home___de-de"
  }, {
    path: "/de-de/search/",
    component: _0eebda1a,
    pathToRegexpOptions: {"strict":true},
    name: "search___de-de"
  }, {
    path: "/de-de/sitemap/",
    component: _a5de770c,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___de-de"
  }, {
    path: "/de-de/stripe-3d-auth-complete/",
    component: _c25a9b72,
    pathToRegexpOptions: {"strict":true},
    name: "stripe-3d-auth-complete___de-de"
  }, {
    path: "/de-de/sub-domain/",
    component: _2ad0d202,
    props: true,
    name: "supplier-home___de-de"
  }, {
    path: "/de-de/teamevent/",
    component: _360d43e5,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent___de-de"
  }, {
    path: "/de-de/terms-and-conditions/",
    component: _bb6b3902,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___de-de"
  }, {
    path: "/de-de/terms-supplier/",
    component: _62db3ec6,
    pathToRegexpOptions: {"strict":true},
    name: "terms-supplier___de-de"
  }, {
    path: "/en-us/account/",
    component: _6f1d25f2,
    pathToRegexpOptions: {"strict":true},
    name: "account___en-us",
    children: [{
      path: "general-info/",
      component: _3df5bec0,
      pathToRegexpOptions: {"strict":true},
      name: "account-general-info___en-us"
    }, {
      path: "orders/",
      component: _22ce405c,
      pathToRegexpOptions: {"strict":true},
      name: "account-orders___en-us"
    }, {
      path: "referral-info/",
      component: _12162bfe,
      pathToRegexpOptions: {"strict":true},
      name: "account-referral-info___en-us"
    }, {
      path: "user-info/",
      component: _f7bd69da,
      pathToRegexpOptions: {"strict":true},
      name: "account-user-info___en-us"
    }]
  }, {
    path: "/en-us/checkout/",
    component: _e56dca5e,
    pathToRegexpOptions: {"strict":true},
    children: [{
      path: "",
      component: _0ad1870a,
      pathToRegexpOptions: {"strict":true},
      name: "checkout___en-us"
    }, {
      path: "order-summary/",
      component: _948c812e,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-order-summary___en-us"
    }, {
      path: "payment/",
      component: _1942ed48,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-payment___en-us"
    }, {
      path: "personal-details/",
      component: _55a08f63,
      pathToRegexpOptions: {"strict":true},
      name: "checkout-personal-details___en-us"
    }]
  }, {
    path: "/en-us/event-list-page/",
    component: _4bfef2b0,
    pathToRegexpOptions: {"strict":true},
    name: "event-list-page___en-us"
  }, {
    path: "/en-us/faq/",
    component: _306768db,
    pathToRegexpOptions: {"strict":true},
    name: "faq___en-us"
  }, {
    path: "/en-us/impressum/",
    component: _50af7ffc,
    pathToRegexpOptions: {"strict":true},
    name: "impressum___en-us"
  }, {
    path: "/en-us/login/",
    component: _44b59071,
    pathToRegexpOptions: {"strict":true},
    name: "login___en-us"
  }, {
    path: "/en-us/magazine/",
    component: _5409a21f,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en-us",
    children: [{
      path: "article/",
      component: _20082cf4,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-article___en-us"
    }, {
      path: "category/",
      component: _43098a9e,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-category___en-us"
    }, {
      path: "magazine-wrapper/",
      component: _feda120c,
      pathToRegexpOptions: {"strict":true},
      name: "magazine-magazine-wrapper___en-us"
    }]
  }, {
    path: "/en-us/order-success/",
    component: _3d2ddf09,
    pathToRegexpOptions: {"strict":true},
    name: "order-success___en-us"
  }, {
    path: "/en-us/partner/",
    component: _1e7e0860,
    pathToRegexpOptions: {"strict":true},
    name: "partner___en-us"
  }, {
    path: "/en-us/password-reset/",
    component: _03f99368,
    pathToRegexpOptions: {"strict":true},
    name: "password-reset___en-us"
  }, {
    path: "/en-us/ping-default/",
    component: _7f1e74f1,
    pathToRegexpOptions: {"strict":true},
    name: "ping-default___en-us"
  }, {
    path: "/en-us/ping-optimized/",
    component: _4cc0fed7,
    pathToRegexpOptions: {"strict":true},
    name: "ping-optimized___en-us"
  }, {
    path: "/en-us/ping/",
    component: _df316b06,
    pathToRegexpOptions: {"strict":true},
    name: "ping___en-us"
  }, {
    path: "/en-us/root-domain/",
    component: _074cd0ea,
    props: true,
    name: "home___en-us"
  }, {
    path: "/en-us/search/",
    component: _0eebda1a,
    pathToRegexpOptions: {"strict":true},
    name: "search___en-us"
  }, {
    path: "/en-us/sitemap/",
    component: _a5de770c,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___en-us"
  }, {
    path: "/en-us/stripe-3d-auth-complete/",
    component: _c25a9b72,
    pathToRegexpOptions: {"strict":true},
    name: "stripe-3d-auth-complete___en-us"
  }, {
    path: "/en-us/sub-domain/",
    component: _2ad0d202,
    props: true,
    name: "supplier-home___en-us"
  }, {
    path: "/en-us/teamevent/",
    component: _360d43e5,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent___en-us"
  }, {
    path: "/en-us/terms-and-conditions/",
    component: _bb6b3902,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en-us"
  }, {
    path: "/en-us/terms-supplier/",
    component: _62db3ec6,
    pathToRegexpOptions: {"strict":true},
    name: "terms-supplier___en-us"
  }, {
    path: "/de-de/auth/social-login/",
    component: _e0924fd6,
    pathToRegexpOptions: {"strict":true},
    name: "auth-social-login___de-de"
  }, {
    path: "/de-de/city-category/city-category/",
    component: _4ac12894,
    pathToRegexpOptions: {"strict":true},
    name: "city-category-city-category___de-de"
  }, {
    path: "/de-de/embedded/booking/",
    component: _ba132d42,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-booking___de-de"
  }, {
    path: "/de-de/embedded/button/",
    component: _53b8581c,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-button___de-de"
  }, {
    path: "/de-de/login/forgot-password/",
    component: _01d72b64,
    pathToRegexpOptions: {"strict":true},
    name: "login-forgot-password___de-de"
  }, {
    path: "/de-de/partner/booking-solution/",
    component: _d2538942,
    pathToRegexpOptions: {"strict":true},
    name: "partner-booking-solution___de-de"
  }, {
    path: "/de-de/partner/pricing/",
    component: _10311744,
    pathToRegexpOptions: {"strict":true},
    name: "partner-pricing___de-de"
  }, {
    path: "/de-de/root-domain/giftcard/",
    component: _b843436a,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-giftcard___de-de"
  }, {
    path: "/de-de/root-domain/giftcard/",
    component: _b843436a,
    meta: {"contentGroup":"giftcard"},
    props: true,
    name: "gifcard-page___de-de"
  }, {
    path: "/de-de/root-domain/home/",
    component: _074cd0ea,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-home___de-de"
  }, {
    path: "/de-de/special-giftcard/special-giftcard/",
    component: _54a6e134,
    pathToRegexpOptions: {"strict":true},
    name: "event___de-de"
  }, {
    path: "/de-de/sub-domain/giftcard/",
    component: _74cc1363,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-giftcard___de-de"
  }, {
    path: "/de-de/sub-domain/giftcard/",
    component: _74cc1363,
    props: true,
    name: "supplier-giftcard-page___de-de"
  }, {
    path: "/de-de/sub-domain/home/",
    component: _2ad0d202,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-home___de-de"
  }, {
    path: "/de-de/t/general-event-list-page/",
    component: _466156f0,
    pathToRegexpOptions: {"strict":true},
    name: "t-general-event-list-page___de-de"
  }, {
    path: "/en-us/auth/social-login/",
    component: _e0924fd6,
    pathToRegexpOptions: {"strict":true},
    name: "auth-social-login___en-us"
  }, {
    path: "/en-us/city-category/city-category/",
    component: _4ac12894,
    pathToRegexpOptions: {"strict":true},
    name: "city-category-city-category___en-us"
  }, {
    path: "/en-us/embedded/booking/",
    component: _ba132d42,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-booking___en-us"
  }, {
    path: "/en-us/embedded/button/",
    component: _53b8581c,
    pathToRegexpOptions: {"strict":true},
    name: "embedded-button___en-us"
  }, {
    path: "/en-us/login/forgot-password/",
    component: _01d72b64,
    pathToRegexpOptions: {"strict":true},
    name: "login-forgot-password___en-us"
  }, {
    path: "/en-us/partner/booking-solution/",
    component: _d2538942,
    pathToRegexpOptions: {"strict":true},
    name: "partner-booking-solution___en-us"
  }, {
    path: "/en-us/partner/pricing/",
    component: _10311744,
    pathToRegexpOptions: {"strict":true},
    name: "partner-pricing___en-us"
  }, {
    path: "/en-us/root-domain/giftcard/",
    component: _b843436a,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-giftcard___en-us"
  }, {
    path: "/en-us/root-domain/giftcard/",
    component: _b843436a,
    meta: {"contentGroup":"giftcard"},
    props: true,
    name: "gifcard-page___en-us"
  }, {
    path: "/en-us/root-domain/home/",
    component: _074cd0ea,
    pathToRegexpOptions: {"strict":true},
    name: "root-domain-home___en-us"
  }, {
    path: "/en-us/special-giftcard/special-giftcard/",
    component: _54a6e134,
    pathToRegexpOptions: {"strict":true},
    name: "event___en-us"
  }, {
    path: "/en-us/sub-domain/giftcard/",
    component: _74cc1363,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-giftcard___en-us"
  }, {
    path: "/en-us/sub-domain/giftcard/",
    component: _74cc1363,
    props: true,
    name: "supplier-giftcard-page___en-us"
  }, {
    path: "/en-us/sub-domain/home/",
    component: _2ad0d202,
    pathToRegexpOptions: {"strict":true},
    name: "sub-domain-home___en-us"
  }, {
    path: "/en-us/t/general-event-list-page/",
    component: _466156f0,
    pathToRegexpOptions: {"strict":true},
    name: "t-general-event-list-page___en-us"
  }, {
    path: "/de-de/auth/facebook/callback/",
    component: _e0924fd6,
    meta: {"socialLoginType":"facebook"},
    name: "social-login-facebook___de-de"
  }, {
    path: "/de-de/auth/google/callback/",
    component: _e0924fd6,
    meta: {"socialLoginType":"google"},
    name: "social-login-google___de-de"
  }, {
    path: "/en-us/auth/facebook/callback/",
    component: _e0924fd6,
    meta: {"socialLoginType":"facebook"},
    name: "social-login-facebook___en-us"
  }, {
    path: "/en-us/auth/google/callback/",
    component: _e0924fd6,
    meta: {"socialLoginType":"google"},
    name: "social-login-google___en-us"
  }, {
    path: "/de-de/c/:categorySlug?/",
    component: _5cc41141,
    pathToRegexpOptions: {"strict":true},
    name: "c-categorySlug___de-de"
  }, {
    path: "/de-de/city/:city?/",
    component: _2971bd1e,
    pathToRegexpOptions: {"strict":true},
    name: "city-city___de-de"
  }, {
    path: "/de-de/e/:event?/",
    component: _3e4d8090,
    pathToRegexpOptions: {"strict":true},
    name: "event___de-de",
    children: [{
      path: "",
      component: _2910d15c,
      pathToRegexpOptions: {"strict":true},
      name: "e-event___de-de"
    }, {
      path: "BasicDetails/",
      component: _b7e72bba,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-BasicDetails___de-de"
    }, {
      path: "EventBreadcrumbs/",
      component: _f6177d76,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventBreadcrumbs___de-de"
    }, {
      path: "EventIconList/",
      component: _05bc6b12,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventIconList___de-de",
      children: [{
        path: "EventIconListTable/",
        component: _0a2aad4a,
        pathToRegexpOptions: {"strict":true},
        name: "e-event-EventIconList-EventIconListTable___de-de"
      }]
    }, {
      path: "Gallery/",
      component: _643f8b33,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-Gallery___de-de"
    }, {
      path: "LocationAndMap/",
      component: _393d716e,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-LocationAndMap___de-de"
    }, {
      path: "PrivateEventInfo/",
      component: _c1a3a7d8,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-PrivateEventInfo___de-de"
    }, {
      path: "ReviewShowcase/",
      component: _530bdcd4,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-ReviewShowcase___de-de"
    }, {
      path: "composables/useEventBreadcrumbs/",
      component: _1e1629a0,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useEventBreadcrumbs___de-de"
    }, {
      path: "composables/useKftBuyBox/",
      component: _0541edb6,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useKftBuyBox___de-de"
    }]
  }, {
    path: "/de-de/e/:event/",
    component: _3e4d8090,
    meta: {"contentGroup":"event"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "event-page___de-de"
  }, {
    path: "/de-de/giftcard/:event/",
    component: _54a6e134,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___de-de"
  }, {
    path: "/de-de/giftcard/:event/",
    component: _54a6e134,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___de-de"
  }, {
    path: "/de-de/magazine/:slug/",
    component: _feda120c,
    meta: {"contentGroup":"magazine"},
    props: true,
    name: "magazine-pages___de-de"
  }, {
    path: "/de-de/p/:permalink?/",
    component: _4db5bc14,
    pathToRegexpOptions: {"strict":true},
    name: "p-permalink___de-de"
  }, {
    path: "/de-de/p/:permalink/",
    component: _4db5bc14,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___de-de"
  }, {
    path: "/de-de/p/:permalink/",
    component: _4db5bc14,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___de-de"
  }, {
    path: "/de-de/preview/:previewPermalink?/",
    component: _00bf7940,
    pathToRegexpOptions: {"strict":true},
    name: "preview-previewPermalink___de-de"
  }, {
    path: "/de-de/review/:event?/",
    component: _09dfb092,
    pathToRegexpOptions: {"strict":true},
    name: "review-event___de-de"
  }, {
    path: "/de-de/t/:slug/",
    component: _466156f0,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___de-de"
  }, {
    path: "/de-de/t/:slug/",
    component: _466156f0,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___de-de"
  }, {
    path: "/de-de/teamevent/:city/",
    component: _16d9f15d,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent-city___de-de"
  }, {
    path: "/de-de/teamevent/:city/",
    component: _16d9f15d,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___de-de"
  }, {
    path: "/de-de/teamevent/:city/",
    component: _16d9f15d,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___de-de"
  }, {
    path: "/en-us/c/:categorySlug?/",
    component: _5cc41141,
    pathToRegexpOptions: {"strict":true},
    name: "c-categorySlug___en-us"
  }, {
    path: "/en-us/city/:city?/",
    component: _2971bd1e,
    pathToRegexpOptions: {"strict":true},
    name: "city-city___en-us"
  }, {
    path: "/en-us/e/:event?/",
    component: _3e4d8090,
    pathToRegexpOptions: {"strict":true},
    name: "event___en-us",
    children: [{
      path: "",
      component: _2910d15c,
      pathToRegexpOptions: {"strict":true},
      name: "e-event___en-us"
    }, {
      path: "BasicDetails/",
      component: _b7e72bba,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-BasicDetails___en-us"
    }, {
      path: "EventBreadcrumbs/",
      component: _f6177d76,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventBreadcrumbs___en-us"
    }, {
      path: "EventIconList/",
      component: _05bc6b12,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-EventIconList___en-us",
      children: [{
        path: "EventIconListTable/",
        component: _0a2aad4a,
        pathToRegexpOptions: {"strict":true},
        name: "e-event-EventIconList-EventIconListTable___en-us"
      }]
    }, {
      path: "Gallery/",
      component: _643f8b33,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-Gallery___en-us"
    }, {
      path: "LocationAndMap/",
      component: _393d716e,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-LocationAndMap___en-us"
    }, {
      path: "PrivateEventInfo/",
      component: _c1a3a7d8,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-PrivateEventInfo___en-us"
    }, {
      path: "ReviewShowcase/",
      component: _530bdcd4,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-ReviewShowcase___en-us"
    }, {
      path: "composables/useEventBreadcrumbs/",
      component: _1e1629a0,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useEventBreadcrumbs___en-us"
    }, {
      path: "composables/useKftBuyBox/",
      component: _0541edb6,
      pathToRegexpOptions: {"strict":true},
      name: "e-event-composables-useKftBuyBox___en-us"
    }]
  }, {
    path: "/en-us/e/:event/",
    component: _3e4d8090,
    meta: {"contentGroup":"event"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "event-page___en-us"
  }, {
    path: "/en-us/giftcard/:event/",
    component: _54a6e134,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___en-us"
  }, {
    path: "/en-us/giftcard/:event/",
    component: _54a6e134,
    meta: {"contentGroup":"giftcard"},
    props: true,
    pathToRegexpOptions: {"strict":true},
    name: "special-giftcards___en-us"
  }, {
    path: "/en-us/magazine/:slug/",
    component: _feda120c,
    meta: {"contentGroup":"magazine"},
    props: true,
    name: "magazine-pages___en-us"
  }, {
    path: "/en-us/p/:permalink?/",
    component: _4db5bc14,
    pathToRegexpOptions: {"strict":true},
    name: "p-permalink___en-us"
  }, {
    path: "/en-us/p/:permalink/",
    component: _4db5bc14,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___en-us"
  }, {
    path: "/en-us/p/:permalink/",
    component: _4db5bc14,
    meta: {"contentGroup":"partner"},
    props: true,
    name: "supplier-profile___en-us"
  }, {
    path: "/en-us/preview/:previewPermalink?/",
    component: _00bf7940,
    pathToRegexpOptions: {"strict":true},
    name: "preview-previewPermalink___en-us"
  }, {
    path: "/en-us/review/:event?/",
    component: _09dfb092,
    pathToRegexpOptions: {"strict":true},
    name: "review-event___en-us"
  }, {
    path: "/en-us/t/:slug/",
    component: _466156f0,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___en-us"
  }, {
    path: "/en-us/t/:slug/",
    component: _466156f0,
    meta: {"contentGroup":"tag"},
    props: true,
    name: "general-event-list-page___en-us"
  }, {
    path: "/en-us/teamevent/:city/",
    component: _16d9f15d,
    pathToRegexpOptions: {"strict":true},
    name: "teamevent-city___en-us"
  }, {
    path: "/en-us/teamevent/:city/",
    component: _16d9f15d,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___en-us"
  }, {
    path: "/en-us/teamevent/:city/",
    component: _16d9f15d,
    meta: {"contentGroup":"team event"},
    props: true,
    name: "team-event-page___en-us"
  }, {
    path: "/de-de/:citySlug/",
    component: _2971bd1e,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___de-de"
  }, {
    path: "/de-de/:citySlug/",
    component: _2971bd1e,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___de-de"
  }, {
    path: "/en-us/:citySlug/",
    component: _2971bd1e,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___en-us"
  }, {
    path: "/en-us/:citySlug/",
    component: _2971bd1e,
    meta: {"contentGroup":"city"},
    props: true,
    name: "city-page___en-us"
  }, {
    path: "/de-de/:citySlug/:categorySlug/",
    component: _4ac12894,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___de-de"
  }, {
    path: "/de-de/:citySlug/:categorySlug/",
    component: _4ac12894,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___de-de"
  }, {
    path: "/en-us/:citySlug/:categorySlug/",
    component: _4ac12894,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___en-us"
  }, {
    path: "/en-us/:citySlug/:categorySlug/",
    component: _4ac12894,
    meta: {"contentGroup":"city category"},
    props: true,
    name: "city-categories-page___en-us"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
